import request from "@/utils/request";

export function requestTalabbos() {
  return request({
    url: "talabbos/save",
    method: "post",
  });
}
export function getTalabbosHistory() {
  return request({
    url: "talabbos/gethistory",
    method: "post",
  });
}

export function removeTalabbosRequest(requestID) {
  return request({
    url: "talabbos/remove",
    method: "post",
    data: {
      requestID: requestID,
    },
  });
}

export function download(requestID) {
  return request({
    url: "/talabbos/download",
    method: "post",

    data: { RequestID: requestID },
  });
}

export function hasConfirmPermission() {
  return request({
    url: "/talabbos/hasConfirmPermission",
    method: "post",
  });
}

export function GetStudentState(nationalCode) {
  return request({
    url: "/talabbos/GetStudentState",
    method: "post",
    data: { NationalCode: nationalCode },
  });
}

export function Confirm(studentid, fserial, comment) {
  return request({
    url: "/talabbos/confirm",
    method: "post",
    data: { Fserial: fserial, srlStudent: studentid, Comment: comment },
  });
}
